/**
 * 대메뉴 틀(CRM · IT-CONSULTING) 고르기 — 라우트가 아니라 "메뉴가 놓인 자리"를 따른다.
 *
 * 메뉴 관리에서 IT 메뉴를 CRM 으로 옮겨도 화면 주소(/automation/…)는 그대로다. 예전엔 라우트가
 * 틀을 정해서 옮긴 메뉴를 누르면 좌측 메뉴·상단 바가 원래 대메뉴로 떴다(사용자 신고).
 * 두 레이아웃 모두 <Outlet /> 으로 본문을 그리므로, 틀만 바꿔 끼우면 같은 화면이 그 틀 안에 열린다.
 * 판정은 src/data/menuPlacement.ts 의 frameAreaForPath.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { useMenuRoles } from "../components/auth/MenuRoleContext";
import { frameAreaForPath } from "../data/menuPlacement";
import type { SidebarArea } from "../data/menuPlacement";
import CRMLayout from "./crm/CRMLayout";
import AutomationLayout from "./automation/AutomationLayout";

export default function AreaFrame({ home }: { home: SidebarArea }) {
  const { pathname } = useLocation();
  const { overrides } = useMenuRoles();
  const area = React.useMemo(() => frameAreaForPath(pathname, home, overrides), [pathname, home, overrides]);
  return area === "crm" ? <CRMLayout /> : <AutomationLayout />;
}
